var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1233_16296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06645 3.91177C1.28094 4.93377 0.688633 6.1117 0.34375 7.39134H5.54602L2.06645 3.91177Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6553 7.39137C19.3104 6.11176 18.7181 4.93383 17.9326 3.91183L14.4531 7.39137H19.6553Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 12.6087C0.688672 13.8883 1.28098 15.0663 2.06645 16.0882L5.5459 12.6087H0.34375Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.087 2.06722C15.065 1.28171 13.8871 0.689404 12.6074 0.344482V5.54671L16.087 2.06722Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91016 17.9328C4.93215 18.7183 6.11008 19.3106 7.38969 19.6555V14.4533L3.91016 17.9328Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38965 0.344482C6.11004 0.689404 4.93211 1.28171 3.91016 2.06718L7.38965 5.54667V0.344482Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6074 19.6555C13.887 19.3106 15.065 18.7183 16.0869 17.9328L12.6074 14.4533V19.6555Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 12.6087L17.9326 16.0883C18.7181 15.0663 19.3104 13.8883 19.6553 12.6087H14.4531Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9154 8.69566H11.3044H11.3044V0.0846484C10.8774 0.0290625 10.4421 0 10 0C9.55785 0 9.12262 0.0290625 8.69566 0.0846484V8.69559V8.69563H0.0846484C0.0290625 9.12262 0 9.55793 0 10C0 10.4421 0.0290625 10.8774 0.0846484 11.3043H8.69559H8.69563V19.9154C9.12262 19.9709 9.55785 20 10 20C10.4421 20 10.8774 19.971 11.3043 19.9154V11.3044V11.3044H19.9154C19.9709 10.8774 20 10.4421 20 10C20 9.55793 19.9709 9.12262 19.9154 8.69566Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 12.6087L17.0717 17.0711C17.277 16.8659 17.4727 16.6514 17.6595 16.4291L13.8391 12.6087H12.6094V12.6087Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39207 12.6088H7.39199L2.92969 17.0711C3.13484 17.2763 3.34934 17.4721 3.57168 17.6589L7.39207 13.8384V12.6088Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39195 7.39135V7.39128L2.92961 2.92889C2.72438 3.13405 2.52859 3.34854 2.3418 3.57089L6.16223 7.39132H7.39195V7.39135Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 7.39138L17.0718 2.92896C16.8666 2.72373 16.6521 2.52794 16.4298 2.34119L12.6094 6.16162V7.39138Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1233_16296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/3c50266e.svg";
export { SvgUk as ReactComponent };